// Edit mode detection from URL parameter
// When edit mode is disabled, selection and editing features are hidden

import { isDemoMode } from './demoMode'

/**
 * Check if edit mode is enabled via URL parameter
 * @returns true if ?edit=true is present in URL (but always false in demo mode)
 */
export function isEditMode(): boolean {
  // Demo mode always disables editing
  if (isDemoMode()) {
    return false
  }

  const params = new URLSearchParams(window.location.search)
  return params.get('edit') === 'true'
}

/**
 * Check if MCP WebSocket bridge is enabled via URL parameter or localStorage
 * @returns true if ?mcp=true is present in URL OR localStorage has mcp-enabled=true
 */
export function isMcpEnabled(): boolean {
  const params = new URLSearchParams(window.location.search)
  if (params.get('mcp') === 'true') return true
  return localStorage.getItem('mcp-enabled') === 'true'
}
